module.exports = __webpack_public_path__ + "static/img/20005 (4).43cc8c0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20005 (4).webp
// module id = 4hVi
// module chunks = 14